<template>
  <div class="mng-editor-content">
    <div v-show="dialogVisible" class="viewImage">
      <!-- <div> -->
      <!-- <img  :src="imageurl" width=100% height=100%/> -->
      <!-- </div> -->
      <div ref="demo1" class="demo1" />
      <div class="actions2">
        <div class="ai-button ai-button--primary mng-vr-scene__button" style="min-width: 100px; margin-right: 20px; margin-top: 20px" @click="usethisinstead">
          用本张替换
        </div>
        <div class="ai-button ai-button--primary mng-vr-scene__button" style="min-width: 100px; margin-top: 20px" @click="downloadthis">
          下载
        </div>
        <div class="ai-button ai-button--primary mng-vr-scene__button" style="min-width: 100px; margin-left: 20px; margin-top: 20px" @click="closeview">
          关闭预览
        </div>
      </div>
    </div>
    <div v-if="onMosaicFlag" class="tips">
      {{ mosaicState }}
    </div>
    <div v-show="splicingshow" class="rightbtn">
      <div v-for="n in 6" :key="n" :id="n" class="ai-button ai-button--primary mng-vr-scene__button" style="min-width: 100px" @click="clickimagebtn">
        第{{ n }}张
      </div>
    </div>
    <div class="img-vr-scene">
      <VrScene ref="vrScene" class="img-vr-scene__stage" :scene-id="$route.params.modelId" @toPanoramaId="getID" />
      <div style="
          z-index: 100;
          position: fixed;
          top: 64px;
          right: 0;
          display: flex;
        ">
        <el-input v-model.number="panId" placeholder="全景点ID" />
        <el-button @click="moveToPanoramID">跳转</el-button>
      </div>
      <div class="actions">
        <!-- <div class="ai-button ai-button--primary actions__button" @click="onDownLoad()">
        <i class="material-icons">save</i>
            下载所有图片
        </div>
        <div class="ai-button ai-button--primary actions__button" @click="onUpload()">
        <i class="material-icons">add</i>
           替换图片
        </div> -->
        <div class="btn" @click="refresh">刷新</div>
        <div class="btn" @click="selectPanPic">筛选全景图</div>
        <div class="btn" @click="editOnline">在线修图</div>
        <div class="btn" style="margin-right: 20px" @click="updateAll">
          上传全部图片
        </div>
        <div class="btn" @click="downloadAllImage">下载全部图片</div>
        <div class="btn" @click="downloadAllImageNew">下载全部最新图片</div>
        <div class="btn" @click="mosaicStore">全部打码</div>
        <div class="btn" @click="downloadImage">下载图片</div>
        <div class="btn" @click="downloadImageNew">下载最新图片</div>
        <div class="btn" @click="replaceImage">替换图片</div>
        <div class="btn" @click="mosaicPic">一键打码</div>
        <div class="btn" @click="resetPanorama">恢复初始图片</div>
        <div class="btn" @click="splicingImage">拼接修复</div>
        <div class="btn" @click="downloadmodel">下载模型</div>
        <div class="btn" @click="uplaodmodel">上传模型</div>
        <input v-show="!!0" ref="uploader" type="file" class="upload__input" :accept="accept" @change="previewImage" />
        <input v-show="!!0" ref="uploader2" type="file" class="upload__input" @change="previewImage2" />
        <input v-show="!!0" ref="uploader3" type="file" class="upload__input" multiple="multiple" @change="previewImage3" />
      </div>
      <el-dialog title="全景图选择" :close-on-click-modal="false" :close-on-press-escape="false" :visible.sync="showPanModal" width="80%">
        <div style="height: 60vh; overflow: auto; margin-left: 8px">
          <div class="" v-for="(i, index) in photos" :key="index">
            <h3>方向{{ i.eye + 1 }}</h3>
            <viewer :images="i.imageList" style="display: flex; z-index: 10000000">
              <div class="pic-item" v-for="(p, index) in i.imageList" :key="index">
                <img style="width: 240px; vertical-align: top" :src="`${p.url}${
                    p.key.indexOf('restore') !== -1 ? '?v=' + Math.random() : ''
                  }`" />
                <div class="bottom-option">
                  type:{{ p.key | picKeyFilter
                  }}<input :name="i.eye" :value="p.key" type="radio" v-model="i.selectKey" />
                  <el-button type="primary" @click="editPan(i, p)" size="mini">修图</el-button>
                </div>
              </div>
            </viewer>
          </div>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button @click="showPanModal = false">取 消</el-button>
          <!-- <el-button type="primary" @click="showPanModal = false">确 定</el-button> -->
          <el-button @click="viewPanPic()">确定并替换</el-button>
        </span>
      </el-dialog>
      <el-dialog title="修图" :close-on-click-modal="false" :close-on-press-escape="false" :visible.sync="showPanEditModal" width="80%">
        <div style="height: 60vh; overflow: auto; margin-left: 8px">
          <div class="option">
            <div>按住control可拖动背景图</div>
            <div>左侧图为当前原图,右侧为编辑图片</div>
            <div v-if="rectTarget">
              <div>
                X:<input @change="changeOption" v-model.number="rectTarget.x" class="input" />
              </div>
              <div>
                Y:<input @change="changeOption" v-model.number="rectTarget.y" class="input" />
              </div>
              <div>
                width:<input @change="changeOption" v-model.number="rectTarget.width" class="input" />
              </div>
              <div>
                height:<input @change="changeOption" v-model.number="rectTarget.height" class="input" />
              </div>
              <div>
                是否打码:
                <el-switch @change="changeOption" v-model="rectTarget.mosaic" :active-value="true" :inactive-value="false"></el-switch>
              </div>
              <div>
                <el-button style="margin-left: 8px" @click="delectRect">删除</el-button>
              </div>
              <!-- <el-button @click="saveMask">保存</el-button> -->
            </div>
          </div>
          <div style="display: flex">
            <div ref="view_konva" style="
                width: 360px;
                height: 480px;
                border: 1px solid #ccc;
                margin-right: 24px;
              "></div>
            <div ref="edit_konva" style="width: 360px; height: 480px; border: 1px solid #ccc"></div>
          </div>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button @click="showPanEditModal = false">取 消</el-button>
          <!-- <el-button type="primary" @click="showPanModal = false">确 定</el-button> -->
          <el-button @click="saveMask">确定</el-button>
        </span>
      </el-dialog>
      <el-dialog title="下载中" :show-close="false" :close-on-click-modal="false" :close-on-press-escape="false" :visible.sync="showPanLoadMessage" width="80%">
        <div>当前进度</div>
        <div v-if="sceneData">{{downLength}}/{{panLength}}</div>
        <div>
          下载失败全景点ID
        </div>
        <div v-for="i in errList" :key="i.id">
          {{i.id}}
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import {
  Scene,
  Color,
  PerspectiveCamera,
  WebGLRenderer,
  AxisHelper,
  SpotLight,
  Mesh,
  MeshBasicMaterial,
  Vector3,
  SphereBufferGeometry,
  TextureLoader,
  Vector2
} from 'three'
import 'viewerjs/dist/viewer.css'
import Viewer from 'v-viewer/src/component.vue'

import { type } from 'os'
import axios from 'axios'
import { OrbitControls } from '../../../controls/OrbitControls'
import VrScene from '../../../components/ai-vr-scene.vue'
import store from '../../../store'
import types from '../../../store/mutation-types'
import { Loading } from 'element-ui'
import Stage from './konva/Stege'
import { getAuthorization } from '../../../utils/index.js'
import JSZip from 'jszip'
import FileSaver from 'file-saver'

let ps_amount = 0 // 记录上报数量用 tbd是否需要设置到缓存
export default {
  components: {
    VrScene,
    Viewer
  },
  filters: {
    picKeyFilter(val) {
      if (val.indexOf('completion') !== -1) {
        return val.replace('completion', '补全')
      } else if (val.indexOf('blend') !== -1) {
        return val.replace('blend', '融合')
      } else if (val.indexOf('blend_fblur') !== -1) {
        return val.replace('blend_fblur', '打码')
      } else if (val.indexOf('restore') !== -1) {
        return val.replace('restore', '恢复')
      }
    }
  },
  data() {
    return {
      context: {},
      scene: {},
      pendingLogo: '',
      scenePoint: '',
      panorama_id: '',
      seq_id: '',
      accept: { type: String, default: 'image/*' },
      uploadImg: '',
      onMosaicFlag: !!0,
      interval: null,
      mosaicState: '',
      splicingdata: null,
      splicingshow: false,
      dialogVisible: true,
      imageurl: '',
      updateindex: 0,
      sceneData: null,
      allloadindex: 0,
      showPanModal: false,
      showPanEditModal: false,
      photos: [],
      photoDirectionItem: null,
      editPhotoItem: null,
      rectTarget: null,
      panId: null,
      showPanLoadMessage: false,
      panLength: 0,
      errList: [],
      downLength: 0
    }
  },
  watch: {},
  mounted() {
    this.getMallList()
    this.loadSceneData()
    setTimeout(() => {
      this.queryState()
      this.dialogVisible = false
    }, 500)
    this.initMesh()
  },
  beforeDestroy() {
    if (!this.interval) return
    clearInterval(this.interval)
    this.interval = null
    store.dispatch(types.LOAD_END)
    setTimeout(() => {
      this.onMosaicFlag = !!0
    }, 2000)
  },
  methods: {
    previewImage2() {
      /* eslint-disable */
      const fileReader = new FileReader()
      fileReader.addEventListener(
        'load',
        () => {
          this.uploadImg = fileReader.result
          // console.log(this.uploadImg);
          this.upload2()
        },
        false
      )
      const file = this.$refs.uploader2.files[0] /* eslint-disable */
      if (file) {
        fileReader.readAsDataURL(file)
        // console.log(this.uploadImg);
      }
    },
    previewImage3() {
      this.updateindex = 0
      const fileReader = new FileReader()
      fileReader.addEventListener(
        'load',
        () => {
          this.uploadImg = fileReader.result
          // console.log(this.uploadImg);
          console.log('上传图片:', this.updateindex)
          this.onMosaicFlag = !0
          this.mosaicState =
            '上传图片: ' + this.$refs.uploader3.files[this.updateindex].name
          this.upload3(this.$refs.uploader3.files[this.updateindex].name)
        },
        false
      )
      console.log(this.$refs.uploader3.files)
      const file = this.$refs.uploader3.files[0] /* eslint-disable */
      if (file) {
        fileReader.readAsDataURL(file)
        // console.log(this.uploadImg);
      }
    },
    upload3(name) {
      this.$refs.uploader.value = null
      const randomNumber = this.randomWord(false, 32)

      console.log(
        '/upload/' +
        this.$route.params.modelId +
        '_' +
        randomNumber +
        '/' +
        name
      )
      return new Promise((resolve, reject) => {
        this.$http
          .post(
            '/upload/' +
            this.$route.params.modelId +
            '_' +
            randomNumber +
            '/' +
            name,
            this.uploadImg.substr(
              this.uploadImg.indexOf(',') + 1,
              this.uploadImg.length
            ),
            { headers: { 'Content-Type': 'text/plain' } }
          )
          .then((response) => {
            // console.log(response.data.data[0].url);

            this.uploadedImages(response.data.data[0].url)

            resolve(response.data)
          })
          .catch((error) => {
            console.log(error)
            reject(error)
          })
      })
    },
    async uploadedImages(img) {
      // console.log(img)
      this.uploadImg = null
      try {
        const { data } = await this.$http.post('/admin/update-panorama', {
          vr_id: this.$route.params.modelId,
          url: img
        })

        console.log('加载完成：', this.updateindex)
        this.updateindex++
        ps_amount++
        // 数据上报 修图量
        this.$eventReport({
          event: 'node_value',
          node: 'ps_amount',
          data: ps_amount,
          vr_id: this.$route.params.modelId
        })
        if (this.updateindex < this.$refs.uploader3.files.length) {
          const fileReader = new FileReader()
          fileReader.addEventListener(
            'load',
            () => {
              this.uploadImg = fileReader.result
              console.log('上传图片:', this.updateindex)
              this.onMosaicFlag = !0
              this.mosaicState =
                '上传图片: ' + this.$refs.uploader3.files[this.updateindex].name
              this.upload3(this.$refs.uploader3.files[this.updateindex].name)
            },
            false
          )
          const file =
            this.$refs.uploader3.files[this.updateindex] /* eslint-disable */
          if (file) {
            fileReader.readAsDataURL(file)
          }
        } else {
          this.onMosaicFlag = false
        }
      } catch (error) {
        this.$log('错误：' + error.error_msg)
      }
    },

    upload2() {
      this.$refs.uploader2.value = null
      const randomNumber = this.randomWord(false, 32)

      return new Promise((resolve, reject) => {
        this.$http
          .post(
            '/upload/' +
            this.$route.params.modelId +
            '/' +
            randomNumber +
            '/decimate.obj',
            this.uploadImg.substr(
              this.uploadImg.indexOf(',') + 1,
              this.uploadImg.length
            ),
            { headers: { 'Content-Type': 'text/plain' } }
          )
          .then(async (response) => {
            // console.log(response.data.data[0].url);
            await this.repairMesh(response.data.data[0].url)
            resolve(response.data)
          })
          .catch((error) => {
            console.log('错误错误！！！', error)
            reject(error)
          })
      })
    },
    async repairMesh(url) {
      try {
        const { data } = await this.$http.post('/admin/repair-mesh', {
          vr_id: this.$route.params.modelId,
          obj_url: url
        })
        console.log(data)
        this.$message('修改成功')
      } catch (error) {
        this.$log(error.error_msg)
      }
    },
    previewImage() {
      /* eslint-disable */
      const fileReader = new FileReader()
      fileReader.addEventListener(
        'load',
        () => {
          this.uploadImg = fileReader.result
          // console.log(this.uploadImg);
          this.upload()
          const thethis = this /* eslint-disable */
          const image = new Image()
          image.src = fileReader.result // eslint-disable-next-line
          this.cadSrc = fileReader.result
          image.onload = function () {
            thethis.cadHeight = this.height
            thethis.cadWidth = this.width
          } /* eslint-disable */
        },
        false
      )
      const file = this.$refs.uploader.files[0] /* eslint-disable */
      if (file) {
        fileReader.readAsDataURL(file)
        // console.log(this.uploadImg);
      }
    },

    upload() {
      this.$refs.uploader.value = null
      const randomNumber = this.randomWord(false, 32)
      console.log('替换图片', this.uploadImg)
      console.log(
        '截取',
        this.uploadImg.substr(
          this.uploadImg.indexOf(',') + 1,
          this.uploadImg.length
        )
      )
      return new Promise((resolve, reject) => {
        this.$http
          .post(
            '/upload/map/' + randomNumber + '.jpg',
            this.uploadImg.substr(
              this.uploadImg.indexOf(',') + 1,
              this.uploadImg.length
            ),
            { headers: { 'Content-Type': 'text/plain' } }
          )
          .then((response) => {
            // console.log(response.data.data[0].url);
            console.log(response.data.data[0].url)
            this.changePicture(response.data.data[0].url)
            resolve(response.data)
          })
          .catch((error) => {
            console.log(error)
            reject(error)
          })
      })
    },
    initMesh() {
      this.scene = new Scene() // 场景
      this.camera = new PerspectiveCamera(
        45,
        this.$refs.demo1.clientWidth / this.$refs.demo1.clientHeight,
        0.1,
        1000
      ) // 相机.视场，长宽比，近面，远面
      this.scene.background = new Color(196, 196, 196)
      this.camera.position.x = -15 * 0.8
      this.camera.position.y = 40 * 0.8
      this.camera.position.z = 30 * 0.8
      this.camera.lookAt(this.scene.position)

      this.renderer = new WebGLRenderer({ antialias: true }) // 渲染器
      this.renderer.setSize(
        this.$refs.demo1.clientWidth,
        this.$refs.demo1.clientHeight
      )
      //  this.renderer.shadowMapEnabled = true // 开启阴影
      // const axes = new AxisHelper(20);// 坐标轴

      const spotLight = new SpotLight(0xffffff)
      spotLight.position.set(-40, 200, -10)
      spotLight.castShadow = true

      // this.scene.add(axes);// 场景添加坐标轴

      this.scene.add(this.camera)

      this.scene.add(spotLight)

      this.mcontrols = new OrbitControls(this.camera, this.renderer.domElement)
      console.log(
        '****************************************************method----',
        this.$refs.demo1
      )

      this.$refs.demo1.append(this.renderer.domElement)
      this.renderThisFrame = true
      this.renderScene()

      var geometry = new SphereBufferGeometry(500, 60, 40)
      // invert the geometry on the x-axis so that all of the faces point inward
      geometry.scale(-1, 1, 1)

      // var texture = new THREE.TextureLoader().load( 'textures/2294472375_24a3b8ef46_o.jpg' );
      this.material = new MeshBasicMaterial({ map: null })
      var mesh = new Mesh(geometry, this.material)
      this.scene.add(mesh)

      this.mcontrols.rotateSpeed = -1.0

      //  事件
      this.mcontrols.addEventListener('_render', () => {
        this.renderThisFrame = true
      })
    },
    renderScene() {
      if (this.renderThisFrame) {
        this.renderer.render(this.scene, this.camera)
      }
      this.renderThisFrame = false
      requestAnimationFrame(this.renderScene)
    },
    async clickimagebtn(e) {
      let target = event.target
      this.dialogVisible = true
      this.material.map = null
      this.material.needsUpdate = true
      this.renderThisFrame = true
      store.dispatch(types.LOAD_START)
      this.imageurl =
        this.splicingdata.data[target.getAttribute('id') - 1].panorama_url
      // console.log(target.getAttribute("id"),this.splicingdata.data[target.getAttribute("id")-1]);
      var that = this
      var texture = new TextureLoader().load(this.imageurl, (e) => {
        that.material.map.needsUpdate = true
        that.renderThisFrame = true
        that.material.needsUpdate = true
        store.dispatch(types.LOAD_END)
      })
      this.material.map = texture
    },
    async closeview(e) {
      this.dialogVisible = false
    },
    async usethisinstead(e) {
      await this.changePicture(this.imageurl)
    },
    async downloadthis(e) {
      await axios({
        url: this.imageurl,
        method: 'GET',
        responseType: 'blob' // important
      }).then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]))
        const link = document.createElement('a')
        link.href = url
        link.setAttribute('download', `${this.imageurl}.jpg`) //or any other extension
        document.body.appendChild(link)
        link.click()
      })
    },

    async changePicture(img) {
      // console.log(img)
      this.uploadImg = null
      try {
        const { data } = await this.$http.post('/admin/upload-panorama', {
          store_id: this.$route.params.modelId,
          panorama_id: this.panorama_id,
          seq_id: this.seq_id,
          image_url: img
        })

        console.log(data)
        this.$refs.vrScene.reloadCubeTexture(data.data.panorama_images_low)
        // this.downloadIamge(data.panorama_url);
        // this.downloadIamge3d(data.panorama_url);
        this.showPanModal = false
        this.dialogVisible = false

        ps_amount += 1
        this.$eventReport({
          event: 'node_value',
          node: 'ps_amount',
          data: ps_amount,
          vr_id: this.$route.params.modelId
        })
      } catch (error) {
        this.$log(error.error_msg)
      }
    },
    async downloadmodel() {
      store.dispatch(types.LOAD_START)
      // const url = window.URL.createObjectURL(new Blob([this.$refs.vrScene.vrScene.modelManager.modelPath]));
      const link = document.createElement('a')
      link.href = this.$refs.vrScene.vrScene.modelManager.modelPath
      link.setAttribute('download', `model`) //or any other extension
      document.body.appendChild(link)
      link.click()
      store.dispatch(types.LOAD_END)
      // this.$log(this.$refs.vrScene.vrScene.modelManager.modelPath);
    },
    async uplaodmodel() {
      this.$refs.uploader2.click()
    },
    async splicingImage(rerun) {
      try {
        var str =
          ' https://vrapi.aibee.cn/stitch?code=' +
          this.$route.params.modelId +
          '&panos=' +
          this.panorama_id

        if (rerun === 1) {
          str =
            ' https://vrapi.aibee.cn/stitch?code=' +
            this.$route.params.modelId +
            '&panos=' +
            this.panorama_id +
            '&rerun=1'
        }

        //console.log('splicingImage---:',str);
        this.$http.get(str).then((res) => {
          this.splicingdata = res.data
          if (this.splicingdata.status == 1) {
            confirm('修复中....')
            return
          }
          if (this.splicingdata.status == 2) {
            confirm('修复失败.试图重跑...')
            this.splicingImage(1)
            return
          }
          this.splicingshow = true

          console.log('mosaic', this.splicingdata)
        })
      } catch (error) {
        this.$log(error.error_msg)
      }
    },
    async resetPanorama() {
      try {
        const {
          data: { data }
        } = await this.$http.post('/admin/reset-panorama', {
          store_id: this.$route.params.modelId,
          panorama_id: this.panorama_id,
          seq_id: this.seq_id
        })

        console.log('reset', data)
        this.$refs.vrScene.reloadCubeTexture(data.panorama_images_low)
      } catch (error) {
        this.$log(error.error_msg)
      }
    },
    async mosaicPic() {
      try {
        const {
          data: { data }
        } = await this.$http.post('/admin/mosaic-panorama', {
          store_id: this.$route.params.modelId,
          panorama_id: this.panorama_id,
          seq_id: this.seq_idseq_id
        })

        console.log('mosaic', data.panorama_images_low)
        this.$refs.vrScene.reloadCubeTexture(data.panorama_images_low)
      } catch (error) {
        this.$log(error.error_msg)
      }
    },
    async mosaicStore() {
      try {
        const { data } = await this.$http.post('/admin/mosaic-store', {
          store_id: this.$route.params.modelId
        })

        console.log('mosaic all', data)

        if (data.error_no === 200) {
          this.queryState()
        }
      } catch (error) {
        this.$log(error.error_msg)
      }
    },
    queryState() {
      // if (this.interval != null) {
      //   //判断计时器是否为空
      //   clearInterval(this.interval);
      //   this.interval = null;
      // }
      this.interval = setInterval(() => {
        // 打码功能隐藏 by-qcx 2021-9-23
        // this.getMosaicState()
      }, 2000)
    },
    async getMosaicState() {
      store.dispatch(types.LOAD_START)

      try {
        const {
          data: { data }
        } = await this.$http.post('/admin/mosaic-status', {
          store_id: this.$route.params.modelId
        })

        console.log('mosaic state', data.mosaic_status)

        switch (data.mosaic_status) {
          case -1:
            this.onMosaicFlag = !0
            this.mosaicState = '打码失败'
            clearInterval(this.interval)
            this.interval = null

            setTimeout(() => {
              this.onMosaicFlag = !!0
              store.dispatch(types.LOAD_END)
            }, 2000)
            break
          case 0:
            this.onMosaicFlag = !0

            this.mosaicState = '未打码'
            clearInterval(this.interval)
            this.interval = null
            store.dispatch(types.LOAD_END)
            setTimeout(() => {
              this.onMosaicFlag = !!0
            }, 2000)
            break
          case 1:
            this.onMosaicFlag = !0

            this.mosaicState = '打码成功'
            clearInterval(this.interval)
            this.interval = null
            store.dispatch(types.LOAD_END)
            // const {
            //   data: { data: sceneData }
            // } = await this.$http.post(
            //   "/v1/list-panoramas?secret=U4LOTsSWEASOCXNl4lzyg0rOyGztm1so",
            //   { store_id: this.$route.params.modelId }
            // );
            // console.log(sceneData);
            // sceneData.panorama_list.forEach(v => {
            //   this.$refs.vrScene.reloadCubeTexture(v.panorama_images_low);
            // });

            this.$refs.vrScene.dispose()
            this.$refs.vrScene.initVRScene()

            setTimeout(() => {
              this.onMosaicFlag = !!0
              this.loadDataAndStart()
            }, 2000)
            break
          case 2:
            this.onMosaicFlag = !0

            this.mosaicState = '正在打码'
            store.dispatch(types.LOAD_END)
            break
          default:
            clearInterval(this.interval)
            this.interval = null
            store.dispatch(types.LOAD_END)
            break
        }
      } catch (error) {
        this.$log(error.error_msg)
      }
    },
    async loadSceneData() {
      // 加载数据
      const {
        data: { data: sceneData }
      } = await this.$http.post(
        '/v1/list-panoramas?secret=U4LOTsSWEASOCXNl4lzyg0rOyGztm1so',
        { store_id: this.$route.params.modelId }
      )
      this.sceneData = sceneData
      this.scenePoint = sceneData.panorama_list.map((pano) => {
        const p = {}
        p.panoramaId = pano.coordinate.panorama_id
        p.sequenceId = pano.seq_id
        return p
      })
      //  console.log(this.scenePoint);
    },
    getID({ pID }) {
      console.log('tomoavdfasfd:', pID)
      this.panorama_id = pID
      // console.log(this.scenePoint.filter(v => (v.panoramaId === pID)));

      this.seq_id = this.scenePoint.filter(
        (v) => v.panoramaId === pID
      )[0].sequenceId
    },
    maxLength() {
      if (this.name.length > 10) {
        this.name = String(this.name).slice(0, 10)
      }
      if (this.description.length > 10) {
        this.description = String(this.description).slice(0, 10)
      }
    },
    validateTextLength(value) {
      //  中文、中文标点、全角字符按1长度，英文、英文符号、数字按0.5长度计算
      const cnReg = /([\u4e00-\u9fa5]|[\u3000-\u303F]|[\uFF00-\uFF60])/g
      const mat = value.match(cnReg)
      let length
      if (mat) {
        length = mat.length + (value.length - mat.length) * 0.5
        return length
      }
      return value.length * 0.5
    },
    removeThumb() {
      this.pendingLogo = null
      this.$refs.uploader.clear()
    },
    testChanged() {
      //  console.log(this.name.indexOf('https:'));
      if (this.name.indexOf('https:') !== -1) {
        const gets = this.name.split('https')[0]
        this.name = String(gets)
        //  console.log(gets);
      }
    },
    onDownLoad() { },
    onUpload() { },
    async showErroPage(index) {
      this.erroMsg = String(this.erroMsglink[index])
    },
    async getMallList() {
      try {
        const {
          data: { data }
        } = await this.$http.post(
          '/admin/list-malls?secret=U4LOTsSWEASOCXNl4lzyg0rOyGztm1so',
          { store_id: this.$route.params.modelId }
        )
        this.mallList = data
        this.getStoreInfo()
      } catch (error) {
        this.$log(error.error_msg)
      }
    },
    async getStoreInfo() {
      try {
        const {
          data: { data }
        } = await this.$http.post(
          '/admin/get-store-info?secret=U4LOTsSWEASOCXNl4lzyg0rOyGztm1so',
          { store_id: this.$route.params.modelId }
        )

        this.description = data.description
        this.name = data.store_name
        this.parentMallId = data.parent_mall_id
        this.logo = data.logo
        if (this.name.indexOf('生成失败') !== -1) {
          this.labelVisible = false
          this.errolabelVisible = true
          this.erroMsglink = this.description.split(',')
          this.showErroPage(0)
        }
      } catch (error) {
        this.$log(error.error_msg)
      }
    },
    async updateInfo() {
      try {
        if (this.logosize > 2) {
          this.$message('图片尺寸大于2M,请重新选择')
          return
        }
        const payload = {
          store_id: this.$route.params.modelId,
          store_name: this.name,
          description: this.description,
          parent_mall_id: this.parentMallId
        }
        if (this.pendingLogo) {
          payload.logo = this.pendingLogo.replace(/data:image.*?,/gi, '')
        }
        await this.$http.post(
          '/admin/modify-store-info?secret=U4LOTsSWEASOCXNl4lzyg0rOyGztm1so',
          payload
        )
        this.$message('修改成功')
      } catch (error) {
        console.log('updateInfo  ---- ', error)
        this.$log(error.error_msg)
      }
    },
    onLogoImageChanged(src) {
      this.pendingLogo = src
      if (src) this.removeIcon = true
      else this.removeIcon = false
    },
    onLogoImageSize(size) {
      this.logosize = size / Math.pow(1024, 2)
      if (this.logosize > 2) {
        this.$message('图片尺寸大于2M,请重新选择')
      }
      //  console.log('this.logosize:',this.logosize);
    },
    async updateAll() {
      this.$refs.uploader3.click()
    },
    async downloadAllImage() {
      this.allloadindex = 0
      this.panLength = this.sceneData.panorama_list.filter(e => { return e.visible }).length
      this.downloadnext()
    },
    async downloadAllImageNew() {
      this.allloadindex = 0
      this.panLength = this.sceneData.panorama_list.filter(e => { return e.visible }).length
      this.downloadnextNew()
    },
    // 下载全部
    async loadAllPan() {
      const loadingInstance = Loading.service({ fullscreen: true, text: '全景图下载中' })
      const zip = new JSZip()
      for (let i = 0; i < this.sceneData.panorama_list.length; i++) {
        try {
          const res = await axios({
            url: `/admin/download-panorama?store_id=${this.$route.params.modelId
              }&panorama_id=${this.sceneData.panorama_list[i].id
              }&seq_id=${this.sceneData.panorama_list[i].seq_id}`,
            method: 'GET',
            responseType: 'blob' // important
          })
          zip.file(`${this.sceneData.panorama_list[i].seq_id}.jpg`, res.data, { Blob: true })
        } catch (error) {
        }
      }
      zip.generateAsync({ type: 'blob' }).then(content => {
        FileSaver.saveAs(content, '全景图')
        loadingInstance.close()
      })
    },
    async downloadnext() {
      this.errList = []
      this.showPanLoadMessage = true
      if (this.allloadindex >= this.sceneData.panorama_list.length) return
      if (this.sceneData.panorama_list[this.allloadindex].visible) {
        store.dispatch(types.LOAD_START)
        const params = {
          store_id: this.$route.params.modelId,
          panorama_id: this.sceneData.panorama_list[this.allloadindex].id,
          seq_id: this.sceneData.panorama_list[this.allloadindex].seq_id
        }
        try {
          const response = await axios({
            url: `/admin/download-panorama?store_id=${this.$route.params.modelId
              }&panorama_id=${this.sceneData.panorama_list[this.allloadindex].id
              }&seq_id=${this.sceneData.panorama_list[this.allloadindex].seq_id}`,
            method: 'GET',
            responseType: 'blob' // important
          })
          const url = window.URL.createObjectURL(new Blob([response.data]))
          const link = document.createElement('a')
          link.href = url
          link.setAttribute(
            'download',
            `${this.sceneData.panorama_list[this.allloadindex].seq_id}.jpg`
          ) //or any other extension
          document.body.appendChild(link)
          link.click()
          this.downLength++
        } catch (error) {
          this.errList.push(this.sceneData.panorama_list[this.allloadindex])
        }
        store.dispatch(types.LOAD_END)
        this.allloadindex++
        this.downloadnext()
      } else {
        this.allloadindex++
        this.downloadnext()
      }
    },
    async downloadnextNew() {
      this.errList = []
      this.showPanLoadMessage = true
      if (this.allloadindex >= this.sceneData.panorama_list.length) return
      if (this.sceneData.panorama_list[this.allloadindex].visible) {
        store.dispatch(types.LOAD_START)
        try {
          const response = await axios({
            url: `https://vrapi.aibee.cn/panorama/pea.jpg?vr_id=${this.$route.params.modelId
              }&panorama_id=${this.sceneData.panorama_list[this.allloadindex].id}&seq_id=${this.sceneData.panorama_list[this.allloadindex].seq_id
              }&authorization=${getAuthorization(
                `vr_id=${this.$route.params.modelId}&panorama_id=${this.sceneData.panorama_list[this.allloadindex].id}&seq_id=${this.sceneData.panorama_list[this.allloadindex].seq_id}`,
                'get'
              )}`,
            method: 'GET',
            responseType: 'blob' // important
          })
          const url = window.URL.createObjectURL(new Blob([response.data]))
          const link = document.createElement('a')
          link.href = url
          link.setAttribute(
            'download',
            `original_${this.sceneData.panorama_list[this.allloadindex].seq_id}.jpg`
          ) //or any other extension
          document.body.appendChild(link)
          link.click()
          this.downLength++
        } catch (error) {
          this.errList.push(this.sceneData.panorama_list[this.allloadindex])
        }
        store.dispatch(types.LOAD_END)
        this.allloadindex++
        this.downloadnextNew()
      } else {
        this.allloadindex++
        this.downloadnextNew()
      }
    },
    async downloadImage() {
      store.dispatch(types.LOAD_START)
      const params = {
        store_id: this.$route.params.modelId,
        panorama_id: this.panorama_id,
        seq_id: this.seq_id
      }
      // { responseType: "arraybuffer" },
      await axios({
        url: `/admin/download-panorama?store_id=${this.$route.params.modelId}&panorama_id=${this.panorama_id}&seq_id=${this.seq_id}`,
        method: 'GET',
        responseType: 'blob' // important
      }).then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]))
        const link = document.createElement('a')
        link.href = url
        link.setAttribute('download', `${this.seq_id}.jpg`) //or any other extension
        document.body.appendChild(link)
        link.click()
        store.dispatch(types.LOAD_END)
      })
    },
    async downloadImageNew() {
      store.dispatch(types.LOAD_START)
      // { responseType: "arraybuffer" },
      await axios({
        url: `https://vrapi.aibee.cn/panorama/pea.jpg?vr_id=${this.$route.params.modelId
          }&panorama_id=${this.panorama_id}&seq_id=${this.seq_id
          }&authorization=${getAuthorization(
            `vr_id=${this.$route.params.modelId}&panorama_id=${this.panorama_id}&seq_id=${this.seq_id}`,
            'get'
          )}`,
        method: 'GET',
        responseType: 'blob' // important
      }).then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]))
        const link = document.createElement('a')
        link.href = url
        link.setAttribute('download', `original_${this.seq_id}.jpg`) //or any other extension
        document.body.appendChild(link)
        link.click()
        store.dispatch(types.LOAD_END)
      })
    },

    downloadIamge(imgsrc, name) {
      let src = imgsrc

      var canvas = document.createElement('canvas')
      var img = document.createElement('img')
      img.onload = function (e) {
        canvas.width = img.width
        canvas.height = img.height
        var context = canvas.getContext('2d')
        context.drawImage(img, 0, 0, img.width, img.height)
        // window.navigator.msSaveBlob(canvas.msToBlob(),'image.jpg');
        // saveAs(imageDataUrl, '附件');
        canvas.getContext('2d').drawImage(img, 0, 0, img.width, img.height)
        canvas.toBlob((blob) => {
          let link = document.createElement('a')
          link.href = window.URL.createObjectURL(blob)
          link.download = 'photo'
          link.click()
        }, 'image/jpeg')
        // context.toBlob(function(blob) {
        // console.log('blob :', blob);

        // let link = document.createElement('a');
        // link.href = window.URL.createObjectURL(blob);
        // link.download = 'aaa';
        // }, "image/jpeg");
      }
      img.setAttribute('crossOrigin', 'Anonymous')
      img.src = src
    },
    convertImgToBase64(url, callback, outputFormat) {
      var canvas = document.createElement('CANVAS'),
        ctx = canvas.getContext('2d'),
        img = new Image()
      img.crossOrigin = 'Anonymous'
      img.onload = function () {
        canvas.height = img.height
        canvas.width = img.width
        ctx.drawImage(img, 0, 0)
        var dataURL = canvas.toDataURL(outputFormat || 'image/png')
        callback.call(this, dataURL)
        canvas = null
      }
      img.src = url
    },
    replaceImage() {
      this.$refs.uploader.click()
      // this.previewImage();
      // this.uploadImg = null;
    },
    randomWord(randomFlag, min, max) {
      let str = '',
        range = min,
        arr = [
          '0',
          '1',
          '2',
          '3',
          '4',
          '5',
          '6',
          '7',
          '8',
          '9',
          'a',
          'b',
          'c',
          'd',
          'e',
          'f',
          'g',
          'h',
          'i',
          'j',
          'k',
          'l',
          'm',
          'n',
          'o',
          'p',
          'q',
          'r',
          's',
          't',
          'u',
          'v',
          'w',
          'x',
          'y',
          'z'
        ]
      // 随机产生
      if (randomFlag) {
        range = Math.round(Math.random() * (max - min)) + min
      }
      for (let i = 0; i < range; i++) {
        let pos = Math.round(Math.random() * (arr.length - 1))
        str += arr[pos]
      }
      return str
    },
    async selectPanPic() {
      await this.queryPanPic()
      this.showPanModal = true
    },
    // 刷新
    refresh() {
      this.$refs.vrScene.dispose()
      this.$refs.vrScene.initVRScene()
    },
    // 跳转
    moveToPanoramID() {
      if (!this.panId) return
      this.$refs.vrScene.moveToPanoramID(this.panId)
    },
    // 全景图列表查询
    async queryPanPic() {
      const target = {
        vr_id: this.$route.params.modelId,
        pano_id: this.panorama_id
      }
      const {
        data: { data }
      } = await this.$http.post('/pieye/list', target)
      this.photos = data
      this.photos.forEach((i) => {
        if (!i.image) {
          i.image = []
        }
        i.selectKey = ''
        i.imageList = []
        i.image.forEach((c) => {
          if (c.completion) {
            i.imageList.push({
              mask: c.mask,
              eye: i.eye,
              origin: c.origin,
              url: c.completion,
              key: `${c.index}-completion`
            })
          }
          if (c.blend_fblur) {
            i.imageList.push({
              mask: c.mask,
              eye: i.eye,
              origin: c.origin,
              url: c.blend_fblur,
              key: `${c.index}-blend_fblur`
            })
          }
          if (c.blend) {
            i.imageList.push({
              mask: c.mask,
              eye: i.eye,
              origin: c.origin,
              url: c.blend,
              key: `${c.index}-blend`
            })
          }
          if (c.restore) {
            i.imageList.push({
              mask: c.mask,
              eye: i.eye,
              origin: c.origin,
              url: c.restore,
              key: `${c.index}-restore`
            })
          }
          if (c.selected) {
            i.selectKey = `${c.index}-${c.selected}`
          }
        })
      })
      console.log(this.photos)
    },
    // 在线修图
    async editOnline() {
      store.dispatch(types.LOAD_START)
      // const params = {
      //   store_id: this.$route.params.modelId,
      //   panorama_id: this.panorama_id,
      //   seq_id: this.seq_id
      // }
      let target = {
        files: [
          `https://vrapi.aibee.cn/panorama/pea.jpg?vr_id=${this.$route.params.modelId
          }&panorama_id=${this.panorama_id}&seq_id=${this.seq_id
          }&authorization=${getAuthorization(
            `vr_id=${this.$route.params.modelId}&panorama_id=${this.panorama_id}&seq_id=${this.seq_id}`,
            'get'
          )}`
        ],
        resources: [],
        server: {
          version: 1,
          url: `https://vrapi.aibee.cn/panorama/pea.jpg?vr_id=${this.$route.params.modelId
            }&panorama_id=${this.panorama_id}&seq_id=${this.seq_id
            }&authorization=${getAuthorization(
              `vr_id=${this.$route.params.modelId}&panorama_id=${this.panorama_id}&seq_id=${this.seq_id}`,
              'post'
            )}`,
          // url: 'https://ali-openfaas.aibee.cn/function/deployment-service/map_delivery/file_upload?a=11',
          // url:'https://www.myserver.com/saveImage.php',
          formats: ['jpg']
        },
        environment: {},
        script: ''
      }
      console.log(target)
      // console.log('getAuthorization',getAuthorization())
      window.open(`https://www.photopea.com#${JSON.stringify(target)}`)
      store.dispatch(types.LOAD_END)
      // { responseType: "arraybuffer" },
      // await axios({
      //   url: `/admin/download-panorama?store_id=${this.$route.params.modelId}&panorama_id=${this.panorama_id}&seq_id=${this.seq_id}`,
      //   method: 'GET',
      //   responseType: 'blob' // important
      // }).then((response) => {
      //   const url = window.URL.createObjectURL(new Blob([response.data]))

      // })
    },
    // 全景图预览
    async viewPanPic() {
      // let target = event.target
      // this.dialogVisible = true
      // this.material.map = null
      // this.material.needsUpdate = true
      // this.renderThisFrame = true
      // store.dispatch(types.LOAD_START)
      const target = {
        vr_id: this.$route.params.modelId,
        pano_id: this.panorama_id,
        select: []
      }
      let listBreack = false // 判断是否有未选择的方向
      this.photos.forEach((i) => {
        i.imageList.forEach((c) => {
          if (!i.selectKey) {
            this.$message({
              type: 'warning',
              message: `请选择方向${i.eye + 1}下的图片`
            })
            listBreack = true
            return
          }
          if (c.key === i.selectKey) {
            let item = {
              eye: i.eye,
              index: Number(c.key.split('-')[0]),
              type: c.key.split('-')[1],
              url: c.url
            }
            target.select.push(item)
          }
        })
      })
      if (listBreack) return
      let loading = Loading.service({ fullscreen: true, text: '替换中' })
      console.log(target)
      const {
        data: { data }
      } = await this.$http.post('/pieye/stitch', target)
      await this.$http.post('/pieye/save', target)
      await this.changePicture(data.url)
      loading.close()
    },
    /**
     * 图片修复
     */
    //
    editPan(i, target) {
      this.photoDirectionItem = i
      this.editPhotoItem = target
      this.showPanEditModal = true
      this.$nextTick(() => {
        this.initKonva()
      })
    },
    // 删除
    delectRect() {
      if (!this.el) return
      this.edit_konva.deleteGraphic(this.el.ele.id())
      this.rectTarget = null
    },
    changeOption() {
      if (!this.el) return
      this.el.update()
    },
    async saveMask() {
      console.log()
      let loading = Loading.service({ fullscreen: true, text: '修复中' })
      let target = {
        vr_id: this.$route.params.modelId,
        pano_id: this.panorama_id,
        eye: this.editPhotoItem.eye,
        url: this.editPhotoItem.url,
        origin: this.editPhotoItem.origin,
        mask: this.edit_konva.exportData().graphic_list.map((i) => {
          return {
            height: parseInt(i.height),
            width: parseInt(i.width),
            y: parseInt(i.y),
            x: parseInt(i.x),
            mosaic: i.mosaic
          }
        })
      }
      const {
        data: { data }
      } = await this.$http.post('/pieye/restore', target)
      console.log(data)
      await this.queryPanPic()
      loading.close()
      this.showPanEditModal = false
    },
    // 初始化修图
    initKonva() {
      this.view_konva = new Stage({
        container: this.$refs.view_konva,
        url: this.editPhotoItem.origin,
        listeners: {
          errorHandler: (err) => {
            this.$message({
              type: 'error',
              message: err
            })
          },
          changeStageState: (type) => {
            this.state = type
          },
          blockClickHandler: (el, a, b) => {
            // this.target = el
            // if (el) {
            //   this.areaModal = true
            // }
          }
        }
      })
      this.edit_konva = new Stage({
        container: this.$refs.edit_konva,
        url: this.editPhotoItem.url,
        listeners: {
          errorHandler: (err) => {
            this.$message({
              type: 'error',
              message: err
            })
          },
          changeStageState: (type) => {
            this.state = type
          },
          blockClickHandler: (e, target, b) => {
            console.log(e)
            if (e) {
              this.el = target
              this.rectTarget = target.option
            } else {
              this.el = null
              this.rectTarget = null
            }
          },
          change: () => {
            this.view_konva.loadGraphics(
              this.edit_konva.exportData().graphic_list
            )
          }
        }
      })
      this.edit_konva.changeStageState('edit')
      this.view_konva.loadGraphics(this.editPhotoItem.mask)
      this.edit_konva.loadGraphics(this.editPhotoItem.mask)
    }
  }
}
</script>

<style lang="scss" scoped>
.actions {
  width: 100%;
  margin: 20px;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  // justify-content: center;

  .btn {
    margin-top: 8px;
    width: 118px;
    height: 28px;
    font-size: 12px;
    border: 1px solid #ffffff;
    border-radius: 4px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #9e9e9e;
    margin-left: 20px;
    cursor: pointer;
  }

  &__icon {
    margin: 0;
    font-size: 14px;
    color: #9e9e9e;
  }

  &__button {
    width: 118px;
    height: 28px;
    font-size: 11px;
    margin: 0 5px;
    border: 1px solid #ffffff;
    border-radius: 4px;

    .material-icons {
      margin-right: 0;
      font-size: 14px;
    }

    &--small {
      width: 46px;
    }

    &--danger {
      color: #f50;
      border-color: #f50;
    }
  }
}

.image-uploads {
  display: flex;
  justify-content: space-between;
  padding: 0 27px;

  &__text {
    color: #666;
    font-size: 12px;
    line-height: 18px;
    text-align: center;
    user-select: none;

    &--sub {
      font-size: 8px;
    }
  }

  &__imageremove {
    position: absolute;
    margin-top: 5px;
    margin-left: 85px;
    width: 14px;
    height: 14px;
    border-radius: 50%;
    background-color: #f50;
    color: white;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 12px;
    cursor: pointer;
    user-select: none;
  }
}
.tips {
  position: absolute;
  width: 100px;
  height: 50px;
  left: 50%;
  top: 50%;
  z-index: 200;
  transform: translate(-50%, -50%);
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #ffffff;
}
.rightbtn {
  position: absolute;
  width: 100px;
  height: 50px;
  right: 100px;
  top: 80px;
  z-index: 300;
}
.viewImage {
  position: absolute;
  width: 1000px;
  height: calc(100vh - 202px);
  border: 1px solid black;
  padding: 5px;
  left: calc(50% - 500px);
  top: 0px;
  z-index: 40000;
  background-color: #000000;
}

.demo1 {
  width: 100%;
  height: calc(100vh - 202px);
  position: absolute;
  z-index: 401;
  background-color: #000000;
}
.actions2 {
  top: calc(100vh - 202px);
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  z-index: 401;
  background-color: #000000;
}
.pic-item {
  margin-right: 8px;
  .bottom-option {
    box-sizing: border-box;
    display: flex;
    align-items: center;
    border: 1px solid #ccc;
    input {
      margin-top: -2px;
      margin-right: 12px;
    }
  }
}
.option {
  float: right;
  height: 32px;
  margin-bottom: 8px;
  .input {
    margin-right: 16px;
    width: 80px;
  }
  div {
    margin-top: 8px;
  }
}
</style>
